import objectAssign from "object-assign";
import actionTypes from "actionTypes";

const generateSessionId = function() {
	return Math.floor(100000 + Math.random() * 900000);
};
const initialState = {
	email: "",
	authToken: "",
	name: "",
	isLoggedIn: false,
	id: "",
	sessionId: generateSessionId()
};
export default function userReducer(state = initialState, action) {
	let newState = null;
	switch (action.type) {
		case actionTypes.LOGIN_USER:
			newState = objectAssign({}, state, action.payload);
			newState.isLoggedIn = true;
			return newState;
		case actionTypes.LOGOUT_USER:
			newState = objectAssign({}, initialState);
			return newState;
		case actionTypes.GENERATE_NEW_SESSION_ID:
			newState = objectAssign({}, state);
			newState.sessionId = generateSessionId();
			return newState;
	}
	return state;
}
